import { z } from 'zod';
import { componentStyleSchema } from '../component-catalog.js';
const commonOptionals = {
    queryConfig: z.record(z.string(), z.unknown()).optional(),
    minimized: z.boolean().optional(),
    displayConfig: z.record(z.string(), z.unknown()).optional(),
    annotations: z.array(z.record(z.string(), z.unknown())).optional(),
    style: componentStyleSchema.optional(),
};
const propsSchema = z
    .object({
    sourceDataset: z.string(),
    mapping: z
        .object({
        source: z.string(),
        target: z.string(),
        value: z.string(),
    })
        .strict(),
    ...commonOptionals,
})
    .strict();
export const sankeyChartDefinition = {
    type: 'SankeyChart',
    category: 'data',
    propsSchema,
    isDataBacked: true,
    columnRefManifest: ['source', 'target', 'value'],
    needsMeasuredDims: true,
    defaultMinHeight: 200,
    description: 'Sankey diagram over a dataset. Props: sourceDataset (required), mapping ({ source: string, target: string, value: string }).',
};
//# sourceMappingURL=SankeyChart.js.map